<template>
  <div
    v-if="this.visible"
    class="fixed top-0 left-0 z-[9998] grid h-screen w-screen bg-black bg-opacity-70 px-8 py-4 overflow-y-auto"
    @click.self="onBackgroundClick"
  >
    <ac-card
      class="relative z-[9999] m-auto rounded-md bg-white py-4 px-6"
    >
      <div class="absolute top-4 right-4" @click="onContentCloseClick">
        <icon-cross class="h-6 w-6 cursor-pointer text-orange" />
      </div>

      <div class="hidden md:mr-10 md:flex md:flex-grow md:justify-end">
        Sort Industries by:&nbsp;
        <span
          :class="viewChoiceClasses('alphabetical')"
          @click="setView('alphabetical')"
        >
          A-Z
        </span>
        &nbsp;|&nbsp;
        <span
          :class="viewChoiceClasses('category')"
          @click="setView('category')"
        >
          Category
        </span>
      </div>

      <div class="flex flex-col gap-4 md:flex-row">
        <div class="hidden sm:block md:flex-[1]">
          <h3 class="text-xl font-bold leading-8 text-blue">Most Popular</h3>
          <h4 class="font-bold text-blue">Top 15 industries</h4>
          <ul>
            <li
              class="cursor-pointer py-1"
              v-for="industry in getTop15Industries"
              :key="industry.IndustryID"
              @click.stop="selectIndustry(industry.AC_industry_id)"
            >
              {{ industry.industry_name_1 }}
            </li>
          </ul>
        </div>

        <div class="flex-[3]">
          <div
            class="block"
            :class="viewIndustryOptionsClasses('alphabetical')"
          >
            <h3
              class="mb-2 hidden text-xl font-medium leading-8 text-blue sm:block"
            >
              All Industries A-Z
              <span
                class="rounded-xl bg-grey-20 p-1 text-xs font-bold text-grey-50"
                >Number of Agencies</span
              >
            </h3>
            <ul class="industry-modal-alphabetical">
              <li
                class="flex cursor-pointer justify-between py-1 pr-6 hover:underline sm:block sm:pr-0"
                v-for="industry in industryCounts"
                :key="industry.industry_key"
                @click.stop="selectIndustry(industry.industry_key)"
              >
                {{ industry.industry_name }}
                <span class="pill">{{ industry.agency_count }}</span>
              </li>
            </ul>
          </div>

          <div class="hidden" :class="viewIndustryOptionsClasses('category')">
            <h3 class="mb-2 text-xl font-medium leading-8 text-blue">
              All Industries (Categorical)
              <span class="pill">Number of Agencies</span>
            </h3>
            <div class="flex flex-row gap-4">
              <div class="flex-[1]">
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Technical, Industrial & Scientific
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('technical')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Education, Healthcare & Social Assistance
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('social')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
              </div>
              <div class="flex-[1]">
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Office & Commercial
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('office')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Financial / Insurance
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('financial')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Miscellaneous
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('misc')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Charity / Voluntary
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('voluntary')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
              </div>
              <div class="flex-[1]">
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Fashion & Retail
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('fashion')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Senior & Executive Appointments
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('executive')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">
                  Media, Arts & Leisure
                </h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('media')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
                <h4 class="text-xl font-bold leading-6 text-blue">Transport</h4>
                <ul class="mb-4">
                  <li
                    class="cursor-pointer py-1 hover:underline"
                    v-for="industry in getCategory('transport')"
                    :key="industry.industry_key"
                    @click.stop="selectIndustry(industry.industry_key)"
                  >
                    {{ industry.industry_name }}
                    <span class="pill">{{ industry.agency_count }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ac-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AcCard from 'Components/AcCard.vue';
import IconCross from 'Components/Icons/IconCross';

export default {
  name: 'IndustrySelect',
  components: {
    AcCard,
    IconCross,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      description:
        'Whether or not the modal is visible. Allows the modal to be controlled from outside of the component.',
    },
  },
  data() {
    return {
      view: 'alphabetical', // alphabetical, category
    };
  },
  computed: {
    ...mapState('info', ['industryCounts']),
    ...mapGetters('info', [
      'getTop15Industries',
      'getCategory',
      'getIndustryAgencyCount',
    ]),
  },
  methods: {
    setView(view) {
      this.view = view;
    },
    onBackgroundClick() {
      this.$emit('onBackgroundClick');
    },
    onContentClick() {
      this.$emit('onContentClick');
    },
    onContentCloseClick() {
      this.$emit('onContentCloseClick');
    },
    selectIndustry(industry) {
      this.$emit('selectIndustry', industry);
    },
    viewChoiceClasses(view) {
      const activeClasses = ['font-bold', 'cursor-default'];
      const inactiveClasses = ['cursor-pointer'];
      return view === this.view ? activeClasses : inactiveClasses;
    },
    viewIndustryOptionsClasses(view) {
      return view === this.view ? ['md:block'] : ['md:hidden'];
    },
  },
};
</script>
